import axios from "axios";

export const loadSummaryData =()=>(dispatch, getState)=>{
          axios.get('../details2.json')
          .then(res => {
            const summary = res.data.summaryData;
            dispatch(loadSummaryDataSuccess(summary));
          });
};

export const loadSummaryDataSuccess = (data) => {
  return {
    type: "SUMMARY_DATA_LOADED",
    data: data
  }
};


// WEBPACK FOOTER //
// ./src/actions/index.js